import React, { useState } from 'react';
import './App.css';

const PHONE = '9741884505';
const PHONE_TEL = '+919741884505';

const WA_NUMBER = '9943244591';
const WA_MESSAGE = "Hi, I need laptop or computer repair service. I'm in Bangalore. Please let me know how we can proceed.";
const WA_URL = `https://wa.me/91${WA_NUMBER}?text=${encodeURIComponent(WA_MESSAGE)}`;

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thanks for reaching out! We'll get back to you within 24 hours.");
    e.target.reset();
  };

  const services = [
    {
      title: 'Laptop Screen Repair & Replacement',
      icon: '💻',
      image: 'https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=600&q=80',
      description: 'Cracked, flickering, or dead display? We replace laptop screens with quality parts so you get a clear picture and no more lines or black spots. We work on all major brands — Dell, HP, Lenovo, Asus, Acer, Apple — and get you fast results so you’re not stuck without your machine.',
      benefit: 'Quality parts • All brands • Fast turnaround',
    },
    {
      title: 'Battery Replacement',
      icon: '🔋',
      image: 'https://images.unsplash.com/photo-1593642632559-0c6d11fc63ef?w=600&q=80',
      description: 'Is your laptop dying in an hour or only working when plugged in? A worn-out battery is common after 2–3 years. We fit genuine or high-grade compatible batteries so you can work from anywhere again. We also check charging circuits so the new battery lasts.',
      benefit: 'Longer backup • No more plug dependency',
    },
    {
      title: 'Hardware Repair — Keyboard, Trackpad, Ports',
      icon: '🔧',
      image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&q=80',
      description: 'Keys not typing, trackpad jumping, USB or charging port loose? We fix keyboards, trackpads, hinges, and ports so your laptop feels solid again. No need to run to a big store — we come to you, diagnose, and repair with the right parts.',
      benefit: 'Keyboard, trackpad, hinges, ports — all under one roof',
    },
    {
      title: 'Virus & Malware Removal',
      icon: '🛡️',
      image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&q=80',
      description: 'Slow PC, pop-ups, or suspicious behavior? We remove viruses, malware, and bloatware safely and secure your system. We also set up basic protection and tips so you’re less likely to get infected again. Your data stays private and we don’t touch your files unless needed.',
      benefit: 'Faster, cleaner, and more secure PC',
    },
    {
      title: 'Data Recovery',
      icon: '💾',
      image: 'https://images.unsplash.com/photo-1597876931110-5e2d4c243126?w=600&q=80',
      description: 'Accidentally deleted files or drive not detected? We attempt data recovery from hard drives and SSDs. We don’t open disks unnecessarily — we first assess and then use safe methods to recover as much as possible. Best to stop using the device and call us soon.',
      benefit: 'Safe recovery • No overwriting • Confidential handling',
    },
    {
      title: 'Performance Upgrade — RAM & SSD',
      icon: '🚀',
      image: 'https://images.unsplash.com/photo-1591799264318-7e6ef8ddb7ea?w=600&q=80',
      description: 'Laptop too slow for work or college? We upgrade RAM and replace HDD with SSD so boot time and daily use feel much snappier. We recommend the right capacity and install everything properly so you get the best speed without overspending.',
      benefit: 'Faster boot and multitasking • Clear advice',
    },
    {
      title: 'Software Installation & Setup',
      icon: '📀',
      image: 'https://images.unsplash.com/photo-1555617981-dac3880eac6e?w=600&q=80',
      description: 'Need Windows reinstall, drivers, or antivirus? We install and configure Windows, essential software, and drivers so your laptop runs smoothly. We can also set up backup and basic security so you’re good to go from day one.',
      benefit: 'Clean Windows • Drivers • Antivirus • Ready to use',
    },
    {
      title: 'Home Pickup & Doorstep Service',
      icon: '🏠',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80',
      description: 'We pick up your laptop or computer from your home or office in Bangalore. No need to travel — just call us, we schedule a convenient time, collect the device, and bring it back after repair. Same care and quality as a shop, with the convenience of your location.',
      benefit: 'Free pickup • Service at your place • Bangalore-wide',
    },
  ];

  return (
    <div className="App">
      {/* Trust bar */}
      <div className="trust-bar">
        <div className="container trust-bar-inner">
          <span className="trust-item">📞 Call {PHONE} — We respond within 24 hours</span>
          <span className="trust-item">🚗 Free pickup at your place (Bangalore)</span>
          <span className="trust-item">⚡ Fast results • Based in HSR Layout</span>
        </div>
      </div>

      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <span className="logo-icon">V</span>
            <span className="logo-text">Vino</span>
          </div>
          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a></li>
            <li><a href="#services" onClick={() => setIsMenuOpen(false)}>Services</a></li>
            <li><a href="#about" onClick={() => setIsMenuOpen(false)}>About</a></li>
            <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
            <li>
              <a href={`tel:${PHONE_TEL}`} className="nav-cta" onClick={() => setIsMenuOpen(false)}>
                Call {PHONE}
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-bg-wrap">
          <img
            src="https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=1920&q=80"
            alt="Laptop and workspace"
            className="hero-bg-image"
          />
          <div className="hero-overlay" />
        </div>
        <div className="hero-content container">
          <h1 className="hero-title">
            Laptop & computer repair
            <br />
            <span className="highlight">at your doorstep</span>
            <br />
            in Bangalore
          </h1>
          <p className="hero-subtitle">
            Hi, I'm <strong>Vino</strong>. I run a small, reliable repair service from <strong>HSR Layout, Bangalore</strong>. 
            Call me for fast, honest repairs — we pick up from your place and get back to you within 24 hours.
          </p>
          <div className="hero-buttons">
            <a href={`tel:${PHONE_TEL}`} className="btn btn-primary">Call {PHONE}</a>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="btn btn-whatsapp">Chat on WhatsApp</a>
            <a href="#contact" className="btn btn-secondary">Get in touch</a>
          </div>
          <div className="hero-promises">
            <div className="promise">
              <span className="promise-icon">⏱</span>
              <span>Response within 24 hours</span>
            </div>
            <div className="promise">
              <span className="promise-icon">🚗</span>
              <span>Free pickup at your place</span>
            </div>
            <div className="promise">
              <span className="promise-icon">⚡</span>
              <span>Fast results</span>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2 className="section-title">What we do for you</h2>
          <p className="section-subtitle">
            From broken screens to slow PCs and virus issues — we handle it all. 
            Each service is done with care so you get faster results and a device you can rely on.
          </p>
          <div className="services-grid">
            {services.map((s, i) => (
              <div key={i} className="service-card">
                <div className="service-card-image-wrap">
                  <img src={s.image} alt={s.title} className="service-card-image" />
                  <span className="service-icon-overlay">{s.icon}</span>
                </div>
                <h3>{s.title}</h3>
                <p className="service-desc">{s.description}</p>
                <p className="service-benefit">{s.benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2 className="section-title">About Vino</h2>
              <p>
                I'm <strong>Vino</strong>, and I run this repair service from <strong>HSR Layout, Bangalore</strong>. 
                I focus on laptops and computers so you don’t have to run to big stores or wait for days.
              </p>
              <p>
                We offer <strong>home pickup</strong> — call us, and we’ll pick up your device from your place. 
                You get a <strong>response within 24 hours</strong>, and we work to give you <strong>fast results</strong> 
                so you’re not without your machine for long.
              </p>
              <p>
                Whether it’s a cracked screen, slow PC, virus, or upgrade — we explain what’s wrong in simple words 
                and give you a clear idea of time and cost. No hidden charges, no unnecessary work.
              </p>
              <div className="about-features">
                <div className="feature">
                  <span className="feature-icon">✓</span>
                  <span>Response within 24 hours</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">✓</span>
                  <span>Free pickup at your place (Bangalore)</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">✓</span>
                  <span>Honest pricing, no hidden charges</span>
                </div>
                <div className="feature">
                  <span className="feature-icon">✓</span>
                  <span>Based in HSR Layout, serving Bangalore</span>
                </div>
              </div>
            </div>
            <div className="about-image">
              <img
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&q=80"
                alt="Team and service"
                className="about-img"
              />
              <p className="about-location">📍 HSR Layout, Bangalore</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2 className="section-title">Get your laptop or computer fixed</h2>
          <p className="section-subtitle">
            Call us for the fastest response. We’ll get back to you within 24 hours and arrange pickup at your place.
          </p>
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-item contact-phone">
                <div className="contact-icon">📞</div>
                <div>
                  <h3>Call Vino</h3>
                  <a href={`tel:${PHONE_TEL}`}>{PHONE}</a>
                  <p>Reach out for any laptop or computer issue. We respond within 24 hours.</p>
                </div>
              </div>
              <div className="contact-item contact-whatsapp">
                <div className="contact-icon">💬</div>
                <div>
                  <h3>WhatsApp</h3>
                  <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="whatsapp-link">Chat on WhatsApp ({WA_NUMBER})</a>
                  <p>Tap to open WhatsApp with a ready message — just send or edit and we’ll get back within 24 hours.</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div>
                  <h3>Location</h3>
                  <p><strong>HSR Layout, Bangalore</strong></p>
                  <p>We serve across Bangalore with free pickup at your place.</p>
                </div>
              </div>
              <div className="contact-cta-box">
                <p>Prefer we call you back? Send a message below with your name and number.</p>
              </div>
            </div>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Your name</label>
                <input type="text" id="name" name="name" placeholder="Your name" required />
              </div>
              <div className="form-group">
                <label htmlFor="phone">Your phone</label>
                <input type="tel" id="phone" name="phone" placeholder="10-digit mobile number" />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email (optional)</label>
                <input type="email" id="email" name="email" placeholder="your@email.com" />
              </div>
              <div className="form-group">
                <label htmlFor="issue">What do you need help with?</label>
                <textarea
                  id="issue"
                  name="issue"
                  rows="4"
                  placeholder="e.g. laptop screen broken, PC very slow, virus issue..."
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-full">
                Send message — we’ll get back in 24 hours
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Vino</h3>
              <p>Laptop & computer repair at your doorstep. HSR Layout, Bangalore.</p>
              <a href={`tel:${PHONE_TEL}`} className="footer-phone">{PHONE}</a>
            </div>
            <div className="footer-section">
              <h4>Quick links</h4>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#contact">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Reach us</h4>
              <p>📍 HSR Layout, Bangalore</p>
              <p>📞 <a href={`tel:${PHONE_TEL}`}>{PHONE}</a></p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Vino. Laptop & computer repair — HSR Layout, Bangalore.</p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp button */}
      <a
        href={WA_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" width="28" height="28" aria-hidden="true">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        <span>WhatsApp</span>
      </a>
    </div>
  );
}

export default App;
